import { Injectable } from '@angular/core';
import { ILatLng, IMapOptions } from 'src/app/core/models/google-map-models';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapConfigService {

  constructor() { }

  public readonly zoomLevel = 6;
  public defaultPos: ILatLng = {lat: 54.522005, lng: -3.083582};

  public boundingBox = {
    bottom: 49.5,
    left: -10.6,
    right: 2,
    top: 61
  };

  getGoogleMapConfig(defaultPos?: ILatLng, isMobile: boolean = false): IMapOptions {
    this.defaultPos = defaultPos || this.defaultPos;

    const mobileConfig: IMapOptions = {
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false
    };

    let desktopConfig: IMapOptions = {
      zoom: this.zoomLevel,
      center: new google.maps.LatLng(this.defaultPos.lat, this.defaultPos.lng),
      mapTypeControlOptions: {
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.SATELLITE
        ]
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: true,
      fullscreenControlOptions:  {
        position: google.maps.ControlPosition.BOTTOM_RIGHT
      },
      gestureHandling: 'cooperative'
    };

    desktopConfig = (isMobile) ? {...desktopConfig, ...mobileConfig} : {...desktopConfig};

    return desktopConfig;
  }

  getGoogleInfoWindowConfig() {

  }

}
